import { RequiredInfoError } from '@/ui/features/background-check/components/background-check-modal/components/RequiredInfoError';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { ClassifierColumns, ClassifierData } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { TableCell, TableRow } from '@mui/material';
import get from 'lodash/get';
import React from 'react';
import useSWR from 'swr';

interface AccountDetailsTableRowProps {
    account: AccountData;
    error: string;
    label: string;
    path: string;
    classifier?: string;
}

export const AccountDetailsTableRow: React.FC<AccountDetailsTableRowProps> = ({ path, label, account, classifier, error }) => {
    const { data, isLoading } = useSWR(
        [classifier],
        () => {
            if (!classifier) {
                return { rows: [], total: 0 };
            }

            try {
                return new StorageClient<ClassifierData, never>(classifier).list({});
            } catch (error) {
                handleErrorSnackbar(error);

                return { rows: [], total: 0 };
            }
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        },
    );

    const classifierData =
        (data?.rows.find((classifierEntry) => classifierEntry.id === get(account, path))?.columns as ClassifierColumns | undefined)?.name ||
        get(account, path);

    return (
        <TableRow key={path}>
            <TableCell sx={{ borderBottom: 'unset', width: 1 / 2 }}>{label}</TableCell>
            <TableCell sx={{ borderBottom: 'unset', width: 1 / 2, fontWeight: 500 }}>
                {!isLoading && (classifier ? classifierData : get(account, path))}
                {error && <RequiredInfoError label={error} />}
            </TableCell>
        </TableRow>
    );
};
